import { useState } from 'react'
import { Button, Company } from '@artprov/design-system'
import { companyApi } from '@/common/api/https'
import BandaCuentaConectada from '../components/BandaCuentaConectada.jsx'
import EncabezadoSeleccionCuenta from '../components/EncabezadoSeleccionCuenta.jsx'
import ToastSeleccionCuenta from '../components/ToastSeleccionCuenta.jsx'
import { useCuentaActiva } from '../hooks/useCuentaActiva.js'
import { useIngresarCuenta } from '../hooks/useIngresarCuenta.js'
import { useToast } from '../hooks/useToast.js'
import { puedeIngresar } from '../util/puedeIngresar.js'
import { COMPANY_ALCANCE, COMPANY_FIELDS, COMPANY_LABEL, COMPANY_TEST_ID } from '../constants/company.js'
import { TEXTOS } from '../constants/textos.js'

/**
 * Selección de cuenta para Admin ART/HyS (PBI #80676): pueden operar sobre
 * cualquier contrato, así que en lugar de una grilla se busca la empresa con
 * el componente `Company` del Design System.
 *
 * `clientes_front` no monta `AxiosProvider`, por eso la instancia de company
 * se pasa explícitamente por `api`.
 */
export default function SeleccionCuentaAdminArt() {
  const { toast, mostrarMensaje, cerrarToast } = useToast()
  const { contratoActivo, razonSocial } = useCuentaActiva()
  const { ingresarCuenta, ingresoEnCurso } = useIngresarCuenta({ onMensaje: mostrarMensaje })

  // P5.a: arranca vacío aunque haya cuenta activa; la activa se informa en la banda.
  const [seleccion, setSeleccion] = useState(null)

  const habilitado = puedeIngresar(seleccion, contratoActivo, ingresoEnCurso)

  const handleIngresar = () => {
    if (habilitado) ingresarCuenta(seleccion)
  }

  return (
    <>
      <BandaCuentaConectada razonSocial={razonSocial} />

      <div className="mt-[20px] mx-[40px] lg:mx-[96px] pb-8">
        <EncabezadoSeleccionCuenta />

        <div className="mt-6 rounded bg-tertiary-98 p-4 md:p-6">
          <div className="rounded border border-tertiary-90 bg-white p-4 md:p-6">
            <Company
              api={companyApi}
              value={seleccion}
              onChange={setSeleccion}
              label={COMPANY_LABEL}
              fields={COMPANY_FIELDS}
              allowInactive={COMPANY_ALCANCE.allowInactive}
              onlyAssociatedCompanies={COMPANY_ALCANCE.onlyAssociatedCompanies}
              // El prototipo no muestra la ayuda de caracteres mínimos.
              noAutoHint
              // Sin readOnly durante el ingreso: en la variante default oculta el
              // buscador y la pantalla saltaría. La cuenta ya viajó en el POST y
              // el botón queda deshabilitado, así que cambiar la selección no afecta.
              data-testid={COMPANY_TEST_ID}
            />
          </div>

          <div className="mt-4 flex justify-end">
            <Button
              variant="primary"
              type="button"
              isDisabled={!habilitado}
              isLoading={ingresoEnCurso}
              onClick={handleIngresar}
            >
              {ingresoEnCurso ? TEXTOS.INGRESANDO : TEXTOS.INGRESAR}
            </Button>
          </div>
        </div>
      </div>

      <ToastSeleccionCuenta toast={toast} onClose={cerrarToast} />
    </>
  )
}
